import React from 'react';

interface NoLinkRouteProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Component for routes that don't navigate (Support, Help Center, etc.)
 */
export const NoLinkRoute: React.FC<NoLinkRouteProps> = ({ children, onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return <div onClick={handleClick}>{children}</div>;
};
